import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect } from "react";
import PrescribedDetails from "src/Pages/Customer/PrescribedDetails";

const DoctorPrescriptionModal = ({
  id,
  onClose,
}: {
  id: string;
  onClose: () => void;
}) => {
  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "auto";
    };
  }, []);
  return (
    <div className="w-screen min-h-screen h-fit p-6 overflow-y-auto bg-black/50 fixed top-0 left-0 z-[9998] flex items-center justify-center">
      <div className="w-[90%] max-w-[850px] max-h-[90vh] bg-white relative rounded-lg flex flex-col">
        <button
          className="modal-close-btn flex items-center justify-center"
          onClick={onClose}
        >
          <FontAwesomeIcon icon={faXmark} className="font-size-13px" />
        </button>
        <div className="flex-1 overflow-y-auto">
          <PrescribedDetails id={id} />
        </div>
      </div>
    </div>
  );
};

export default DoctorPrescriptionModal;
